module.exports = __webpack_public_path__ + "static/media/Contact_Us.f5acd0f2.md";